<template>
    <div class="diolog_style">
        <div class="main_style device_online">
            <div class="selfClose_btn" style="top:10px; right: 20px;" @click="close"></div>
            <div class="or_title">
                <span class="title">{{ title }}</span>
            </div>
            <div class="check_box">
                <div class="form-wrap">
                    <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
                        <el-row>
                            <el-form-item label="起止时间">
                                <DatePicker :init-width="'660px'" :formatType="'YYYY-MM-DD HH:mm:ss'" dateType="timerange" :currentDateList="dateArr" :needInitTime="false" :topPx="'50px'" :leftPx="'-200px'" @dateChange="changeTime">
                                </DatePicker>
                            </el-form-item>
                            <el-form-item label="分厂/所属区域">
                                <el-select v-model="branchFactoryId" filterable placeholder="请选择">
                                    <el-option v-for="item in branchFactoryList" :key="item.nameType" :label="item.name" :value="item.nameType">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生产工艺线">
                                <el-select v-model="processId" filterable placeholder="请选择">
                                    <el-option v-for="item in processList" :key="'process-' + item.id" :label="item.process" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="设备类别">
                                <el-select v-model="deviceClass" @change="devicePrimaryTypeChange" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in devicePrimaryTypeList" :key="item.primaryTypeName" :label="item.primaryTypeName" :value="item.primaryTypeId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="设备类型">
                                <el-select v-model="deviceType" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in deviceTypeList" :key="item.typeName" :label="item.typeName" :value="item.typeId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="设备名称">
                                <el-input v-model="deviceName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <div style="width: 25px"></div>
                            <div class="btn-group">
                                <a class="self_btn" @click="getSearchBtn()">查询</a>
                                <a class="self_btn" @click="getReset()">重置</a>
                            </div>
                        </el-row>

                    </el-form>
                </div>
                <div class="value HuXiaoBo">
                    <img :src="bgImg" :style="{'width':imgW, 'height': imgH}" alt="" />
                    <div :style="{'left':valW, 'top': valH}" class="val_unit"><span>{{ value }}</span> <span class="unit">%</span>
                    </div>
                </div>
            </div>
            <div class="table_box">
                <el-table :data="tableData" v-loading="tableLoading" :empty-text="tableLoading?' ':'暂无数据'" element-loading-background="rgba(255, 255, 0, .0)" element-loading-text="加载中，请稍后..." stripe style="width: 100%" height="100%">
                    <el-table-column type="index" label="序号" width="100" align="center" />
                    <el-table-column v-for="(item, index) in headerList" :prop="item.prop" :key="index" :label="item.label" :width="item.width" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="equipmentName" label="设备名称" align="center">
                    </el-table-column>
                    <el-table-column prop="equipmentCode" label="设备编码" align="center">
                    </el-table-column>
                    <el-table-column prop="supportType" label="保障类型" align="center">
                    </el-table-column>
                    <el-table-column prop="result" label="处理结果" align="center">
                    </el-table-column> -->

                </el-table>
            </div>
            <div class="page_box">
                <el-pagination @current-change="handleCurrentChange" background :current-page="paramsList.pageNo" :page-size="paramsList.pageSize" layout="total,prev, pager, next, jumper" :total="page_total" :pager-count="5"></el-pagination>
            </div>
        </div>
    </div>
</template>
 
 <script>
import jsonData from '/public/static/js/json/operatieCenter.json';
import { dateFormat } from "utils/tools";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
    name: 'dialog',
    components: { DatePicker },
    data () {
        return {
            title: '设备在线率',
            value: '--',
            bgImg: require('./img/5.png'),
            imgW: '188px',
            imgH: '194px',
            valW: '50%',
            valH: "50%",
            isChoose: true,
            tableLoading: false,
            page_total: 0,
            showData: [],
            tableData: [],
            paramsList: {
                startTime: dateFormat(
                    "YYYY-mm-dd HH:MM:SS",
                    new Date(new Date() - 24 * 60 * 60 * 1000)
                ),
                endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
                pageNo: 1,
                pageSize: 20,
            },
            dateArr: [
                new Date(new Date() - 24 * 60 * 60 * 1000),
                new Date(),
            ],

            branchFactoryList: [],
            processList: [],
            sectionList: [],
            deviceTypeList: [],
            devicePrimaryTypeList: [],
            deviceTypeArr: [],
            // 参数
            branchFactoryId: '',
            processId: '',
            deviceClass: '',
            deviceType: '',
            deviceName: '',
            headerList: [
                { label: '日期', prop: 'equipmentName', width: 400 },
                { label: '分厂/所属区域', prop: 'equipmentCode', width: 300 },
                { label: '生产工艺线', prop: 'supportType', width: '' },
                { label: '设备类别', prop: 'equipmentName', width: '' },
                { label: '设备类型', prop: 'equipmentCode', width: '' },
                { label: '设备名称', prop: 'supportType', width: '' },
                { label: '设备编码', prop: 'equipmentName', width: '' },
                { label: '设备在线率', prop: 'supportType', width: '' },
            ]
        }
    },
    computed: {
        dialogValue () {
            return this.$store.state.operationCenterDialog
        }
    },
    watch: {
        branchFactoryId: {
            handler (newVal, oldVal) {
                this.processId = "";
                this.getProcessListResult();
            },
            deep: true,
        },
        dialogValue: {
            handler (newVal, oldVal) {
                console.log("dialogValue", newVal)
                this.title = newVal.params.type
                if (this.title == '设备在线率') {
                    // this.value = newVal.params.value.value
                    this.dateArr = newVal.params.time
                    this.bgImg = require('./img/5.png')
                    this.imgW = '188px'
                    this.imgH = '194px'
                    this.valW = '50%'
                    this.valH = "60px"
                    this.headerList = [
                        { label: '日期', prop: 'timeStr', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactory', width: 200 },
                        { label: '生产工艺线', prop: 'productionLine', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: 130 },
                        { label: '设备类型', prop: 'typeName', width: 250 },
                        { label: '设备名称', prop: 'deviceName', width: 500 },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '设备在线率', prop: 'rate', width: 200 },
                    ]
                    this.getTableData();
                } else if (this.title == '生产治理同步率') {
                    // this.value = newVal.params.value.value
                    this.dateArr = newVal.params.time
                    this.bgImg = require('./img/3.png')
                    this.imgW = '188px'
                    this.imgH = '194px'
                    this.valW = '50%'
                    this.valH = "50%"
                    this.headerList = [
                        { label: '日期', prop: 'timeStr', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactory', width: 200 },
                        { label: '生产工艺线', prop: 'productionLine', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: 130 },
                        { label: '设备类型', prop: 'typeName', width: 250 },
                        { label: '设备名称', prop: 'deviceName', width: 500 },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '生产治理同步率', prop: 'rate', width: 200 },
                    ]
                    this.getTableData();
                } else if (this.title == '高频高幅') {
                    // this.value = newVal.params.value.value
                    this.dateArr = newVal.params.time
                    this.bgImg = require('./img/2.png')
                    this.imgW = '188px'
                    this.imgH = '194px'
                    this.valW = '50%'
                    this.valH = "80px"
                    this.headerList = [
                        { label: '日期', prop: 'timeStr', width: 300 },
                        { label: '分厂/所属区域', prop: 'branchFactory', width: 200 },
                        { label: '生产工艺线', prop: 'productionLine', width: '' },
                        { label: '设备类别', prop: 'primaryTypeName', width: 130 },
                        { label: '设备类型', prop: 'typeName', width: 250 },
                        { label: '设备名称', prop: 'deviceName', width: 500 },
                        { label: '设备编码', prop: 'deviceNo', width: '' },
                        { label: '高频高幅', prop: 'rate', width: 200 },
                    ]
                    this.getTableData();
                }

            },
            deep: true,
            immediate: true
        }
    },
    created () {
        // this.dateArr = [
        //     new Date(new Date() - 24 * 60 * 60 * 1000),
        //     new Date(),
        // ],
        this.getTypeListByCustomerId()
        this.getPrimaryTypeByCustomerId()
        // this.getTableData();
        this.initDate()
    },
    mounted () {
    },
    methods: {
        async initDate () {
            this.branchFactoryList = await this.getFactoryArea();
            this.processList = await this.getProcessList();
            this.sectionList = await this.getSectionList();
        },
        async getSectionList () {
            let that = this;
            return new Promise(function (resolve, reject) {
                if (that.branchFactoryId && that.processId) {
                    let findProcessSectionUrl =
                        CONFIG.requestName + that.$apiOpt.findProcessSection;
                    that.$apiUtils
                        .get(findProcessSectionUrl, {
                            customerId: that.$store.state.customerId,
                            nameType: that.branchFactoryId,
                            process: that.processId,
                            type: "",
                        })
                        .then(function (data) {
                            let list = [];
                            data &&
                                data.forEach((item) => {
                                    if (item) {
                                        list.push(item);
                                    }
                                });
                            let areaAll = [
                                {
                                    id: "",
                                    processSection: "全部",
                                },
                            ];
                            $.merge(areaAll, list);
                            that.sectionId = "";
                            resolve(areaAll);
                        });
                } else {
                    let areaAll = [
                        {
                            id: "",
                            processSection: "全部",
                        },
                    ];
                    that.sectionId = "";
                    resolve(areaAll);
                }
            });
        },
        async getProcessList () {
            let that = this;
            return new Promise(function (resolve, reject) {
                if (that.branchFactoryId) {
                    let findProcessUrl = CONFIG.requestName + that.$apiOpt.findProcess;
                    that.$apiUtils
                        .get(findProcessUrl, {
                            customerId: that.$store.state.customerId,
                            nameType: that.branchFactoryId,
                            type: "",
                        })
                        .then(function (data) {
                            let list = [];
                            data.forEach((item) => {
                                if (item) {
                                    list.push(item);
                                }
                            });
                            let areaAll = [
                                {
                                    id: "",
                                    process: "全部",
                                },
                            ];
                            $.merge(areaAll, list);
                            that.processId = "";
                            resolve(areaAll);
                            //that.processList = areaAll;
                        });
                } else {
                    let areaAll = [
                        {
                            id: "",
                            process: "全部",
                        },
                    ];
                    that.processId = "";
                    resolve(areaAll);
                }
            });
        },
        async getFactoryArea () {
            let that = this;
            return new Promise(function (resolve, reject) {
                let findInventorySelectTwoUrl =
                    CONFIG.requestName + that.$apiOpt.findInventorySelectTwo;
                that.$apiUtils
                    .get(findInventorySelectTwoUrl, {
                        customerId: that.$store.state.customerId,
                        type: "",
                    })
                    .then(function (data) {
                        let list = [];
                        data.forEach((item) => {
                            if (item) {
                                list.push(item);
                            }
                        });
                        let areaAll = [
                            {
                                nameType: "",
                                name: "全厂",
                            },
                        ];
                        $.merge(areaAll, list);
                        resolve(areaAll);
                    });
            });
        },
        async getProcessListResult () {
            this.processList = await this.getProcessList();
            console.log(this.processList);
            this.$forceUpdate();
        },
        // 获取设备类型
        getTypeListByCustomerId () {
            let url = CONFIG.requestName + this.$apiOpt.getTypeListByCustomerId;
            let params = {
                customerId: this.$store.state.customerId
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    this.deviceTypeArr = data
                });
        },
        // 获取设备类别
        getPrimaryTypeByCustomerId () {
            let url = CONFIG.requestName + this.$apiOpt.getPrimaryTypeByCustomerId;
            let params = {
                customerId: this.$store.state.customerId
            }
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    this.devicePrimaryTypeList = data
                });
        },
        devicePrimaryTypeChange(val) {
            console.log('val', val)
            let arr = []
            for (let item of this.deviceTypeArr) {
                if (item.primaryTypeId == val) {
                    arr.push(item)
                }
            }
            
            this.deviceTypeList = arr
        },
        async getTableData () {
            this.tableLoading = true
            let that = this
            let title = this.title
            that.tableData = []
            that.value = '--'
            let url = CONFIG.requestName + this.$apiOpt.deviceStatisticsList;
            let params = { ...this.paramsList }
            params.startTime = this.dateArr[0]? Date.parse(this.dateArr[0]) : ''
            params.endTime = this.dateArr[1]? Date.parse(this.dateArr[1]): ''
            params.customerId = that.$store.state.customerId
            params.branchFactoryId = that.branchFactoryId
            params.productLineId = that.processId
            params.primaryTypeId = that.deviceClass
            params.typeId = that.deviceType
            params.primaryTypeId = that.deviceClass
            params.deviceName = that.deviceName
            if (title == '设备在线率') {
                params.type = 1
            } else if (title == "高频高幅") {
                params.type = 3
            } else if (title == "生产治理同步率") {
                params.type = 2
            }
            try {
                await this.$apiUtils
                .get(url, params)
                .then(data => {
                    that.tableLoading = false
                    for (let item of data.pageInfo.records) {
                        item.rate += '%'
                    }
                    that.tableData = data.pageInfo.records || []
                    that.page_total = data.pageInfo.total || 0
                    that.value = data.rate
                });
            } catch (err) {
                that.tableLoading = false
            }
            
        },
        handleCurrentChange (val) {
            console.log("231", val)
            this.paramsList.pageNo = val;
            this.getTableData();
        },

        getSearchBtn () {
            this.getTableData();
        },

        getReset () {
            this.dateArr = [
                new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
                new Date(),
            ],
                this.branchFactoryId = ''
            this.processId = ''
            this.deviceClass = ''
            this.deviceType = ''
            this.deviceName = ''
            this.getTableData();
        },

        changeTime (date) {
            console.log('date', date)
            this.dateArr = date
        },

        close () {
            this.$store.commit("upDateOperationCenterDialog", { state: false, params: '' });
        }
    }
}
 </script>
 
 <style lang="scss" scoped>
.diolog_style {
    transition: none 0s ease 0s;
    height: 100%;
    border: 2px solid;
    display: flex;
    flex-direction: column;
    border-image: linear-gradient(
            180deg,
            rgba(0, 201.00000321865082, 255, 1),
            rgba(177.88819938898087, 253.6357820034027, 252.12083369493484, 1)
        )
        2 2;
    .main_style {
        flex: 1;
        margin: 12px 18px;
        padding: 0 50px;
        box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4632);
        background: rgba($color: #021b42, $alpha: 0.7);
        display: flex;
        flex-direction: column;
        height: calc(100% - 24px);
        box-sizing: border-box;
        .btn-group {
            margin-right: 70px;
        }
    }
    .or_title {
        font-size: 30px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: 700;
        color: #63f2ef;
        line-height: 36px;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        margin-top: 26px;
    }
    .check_box {
        display: flex;
        align-items: center;
        margin-top: 30px;
        padding-right: 200px;
        position: relative;
        .form_select_style {
            margin-right: 20px;
            span {
                margin-right: 10px;
            }
        }
        .value {
            text-align: center;
            // background: url("./img/tabItem.png") no-repeat center center;
            font-size: 50px;
            font-weight: 400;
            color: #ffffff;
            text-shadow: 4px 4px 20px #092f78;
            display: flex;
            align-items: center;
            justify-content: center;
            background-size: cover;
            position: absolute;
            right: 160px;
            top: -80px;
            img {
                height: 162px;
                width: 210px;
            }
            .val_unit {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                align-items: center;
            }
            .unit {
                font-size: 18px;
                padding-top: 20px;
                padding-left: 2px;
            }
        }
    }
    .isBaoSteel {
        background: #020f3f;
    }
    .box_wrap {
        height: 100%;
    }
    .or_title {
        display: flex;
        .show_more {
            margin-left: auto;
            font-size: 20px;
            margin-right: 10px;
        }
    }
    .table_box {
        background: transparent;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        margin-top: 0px;
        flex: 1;
        .el-table {
            background: transparent;
        }
        :deep(.el-table) {
            &::before {
                height: 0px !important;
            }
            th > .cell {
                color: #49d9d2 !important;
                font-size: 20px;
            }

            tbody {
                .cell {
                    color: #c6d6df;
                }
                .el-table__row {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%
                    );
                    // border: 1px solid #8BADFF;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }

                .el-table__row--striped {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    ) !important;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }
            }
        }
        :deep(.el-table__header) {
            width: auto !important;
            .has-gutter {
                height: 50px;
                background: transparent;
                // filter: blur(38.08000183105469px);
                border: 1px solid #84aaff;
                tr th {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    );
                    border-bottom: 1px solid #8badff;
                }
            }
        }
        :deep(.el-table__header-wrapper) {
            // border: 1px solid rgba(132, 170, 255, 0.4);
        }
        :deep(.el-table th > .cell) {
            white-space: initial;
            overflow: initial;
            font-size: 24px;
            color: #47ffdd !important;
        }
        :deep(.el-table__body) {
            width: auto !important;
        }
        // :deep(.el-table__body td) {
        //     border: none;
        // }
        :deep(.el-table__body-wrapper) {
            overflow-x: hidden;
            .el-table__empty-block {
                width: auto !important;
            }
        }
    }
    .page_box {
        width: 100%;
        margin-top: 10px;
        padding-bottom: 10px;
        :deep(.el-pager) {
            li {
                background-color: transparent !important;
            }
        }
        :deep(.el-pagination) {
            padding-right: 50px !important;
            font-size: 29px !important;
            button {
                height: 28px !important;
                line-height: 28px !important;
                width: 10px;
            }
            li {
                height: 28px !important;
                line-height: 28px !important;
                width: 40px !important;
                font-size: 22px !important;
                color: #fff;
            }
            li:not(.disabled).active {
                color: #32c5ff;
            }
            .btn-prev {
                background: none !important ;
                color: white !important;
            }

            .btn-next {
                background: none !important;
                color: white !important;
            }
            .el-pagination__total {
                font-size: 22px !important;
            }
            .el-pagination__jump {
                font-size: 22px !important;
            }
        }
    }
}
</style>

<style lang="scss">
.diolog_style {
    .device_online {
        .el-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    .el-table::before {
        height: 0px !important;
    }
    .el-form--inline .el-form-item {
        margin: 0;
        display: flex;
        align-items: center;
        margin-right: 70px;
    }

    .check_box {
        .el-row {
            margin-bottom: 20px;
        }
        .el-select {
            height: 40px;
        }
        .el-form-item .el-form-item__label {
            padding-right: 20px;
            font-weight: 400;
            color: #32c5ff;
            font-size: 24px;
        }
        .date-picker-editor_dark {
            // background: rgba($color: #021B42, $alpha: 0.7);
            border: 1px solid #32c5ff;
            background: rgba(0, 0, 0, 0.1) !important;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
            border-radius: 6px 6px 6px 6px;
            font-size: 20px;
            span {
                color: #fff !important;
            }
        }
        .date-picker-wrap .date-eidtor .date-edit-input {
            font-size: 22px;
        }
        .date-picker-editor_dark > i {
            color: #fff !important;
        }
        .el-input .el-input__inner {
            background: rgba(0, 0, 0, 0.2002);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            border: 1px solid #32c5ff;
            height: 40px;
            color: #fff;
            width: 200px;
            font-size: 22px;
        }
        .date-bottom .select-trigger .el-input .el-input__inner {
            border: inherit;
            height: inherit;
            color: inherit;
            width: inherit;
            font-size: inherit;
        }
        .el-select .select-trigger .el-input .el-input__inner {
            background: rgba(0, 0, 0, 0.2002);
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            border: 1px solid #32c5ff;
            height: 40px;
            color: #fff;
        }
        .diolog_style .table_box .el-table th > .cell {
            font-size: 22px !important;
        }
    }

    .page_box .el-pagination__editor .el-input__inner {
        font-size: 20px;
        height: 32px;
        background: rgba(0, 0, 0, 0.2002);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        border: 1px solid #32c5ff;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td {
    }
}
</style>
 